import { Component, OnInit, Input } from '@angular/core';
import { IPromocionHomeCardDetails } from '@common/interfaces/promocion-home-card-details.interface';




@Component({
  selector: 'app-promociones-home-item',
  templateUrl: './promociones-home-item.component.html',
  styleUrls: ['./promociones-home-item.component.scss'],
})
export class PromocionesHomeItemComponent{

  @Input() item!: IPromocionHomeCardDetails;
  constructor() { }

}
